import React from 'react'
import Element from 'layouts/Element'

export default class Block extends Element {
  static get defaultProps () {
    return {
      filled: true
    }
  }

  get defaultClassNames () {
    return ['content-block', (this.props.filled ? 'filled' : '')]
  }

  render () {
    return (
      <div className={this.classNames}>
        {this.props.children}
      </div>
    )
  }
}
